import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "20 PROOF";
const DEFAULT_DESC =
  "Honest conversations, through podcasts, essays, and community for ambitious 20-somethings — career, money, and relationships, and the messy art of growing up. Welcome to the decade of becoming.";
const ogDefault = () =>
  (typeof window !== "undefined" ? window.location.origin : "") + "/og-default.png?v=2";

const SEO = ({ title, description, image, type = "article" }) => {
  const fullTitle = title ? `${title} · ${SITE}` : `${SITE} · The decade of becoming`;
  const desc = description || DEFAULT_DESC;
  const img = image || ogDefault();
  const url = typeof window !== "undefined" ? window.location.href : "";
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const isHome = type === "website";
  const ldJson = isHome
    ? {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: SITE,
        alternateName: "20 PROOF Media",
        url: origin || undefined,
        description: DEFAULT_DESC,
        publisher: {
          "@type": "Organization",
          name: SITE,
          url: origin || undefined,
          logo: origin ? `${origin}/favicon-512.png` : undefined,
        },
      }
    : null;
  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      {url && <meta property="og:url" content={url} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      {ldJson && <script type="application/ld+json">{JSON.stringify(ldJson)}</script>}
    </Helmet>
  );
};

export default SEO;
